<template lang="pug">
	div(v-if='isRefresh')
		div(v-show='status!="DISAPPROVED"')
			form-wizard(ref='StatusProgress' title="" subtitle="" v-bind:start-index='activeTab')
				//- template(slot='step' scope='props')
					wizard-step(v-bind:tab='props.tab'
						:transition="props.transition"
						index="props.index")
				
				tab-content(title='Pending' icon='far fa-clock')
				tab-content(title='Receive' icon='far fa-file-alt')
				tab-content(title='Validated' icon='fa fa-tasks')
				tab-content(title='Approved' icon='far fa-thumbs-up')
				//- tab-content(title='Release' icon='far fa-check-circle')
				tab-content(title='Disbursement' icon='far fa-check-circle')
		div.text-center.p-3(v-show='status=="DISAPPROVED"')
			h1.text-danger
				|  {{$t('loan_status.disapprove_title')}}
			p {{remarks||$t('loan_status.no_remark')}}
</template>

<script>
export default {
	props: {
		status: {
			default: ''
		},
		remarks: null
	},

  name: 'loan-status',

  data () {
    return {
    	isRefresh: true,
    	statusMap: {

				PENDING: 0,
				RECEIVED: 1,
				VALIDATED: 2,
				APPROVED: 3,
				DISBURSEMENT: 4,
				// RELEASED: 0,
				DISAPPROVED: 5,
			}
    }
  },

  watch: {
  	status(newVal, oldVal) {
  		this.isRefresh=false
  		setTimeout(() => {
  			this.isRefresh=true
  			this.$nextTick(() => {
  				setTimeout(() => {
	  				this.$refs.StatusProgress.activateAll()
	  			},1)
  			})
  		},1)
  	}
  },

  mounted() {
  	this.$refs.StatusProgress.activateAll()
  },

  computed: {
  	/**
  	 * [activeTab description]
  	 * @return {[type]} [description]
  	 */
  	activeTab() {
  		return this.statusMap[this.status]||0
  	}
  }
}
</script>

<style lang="css" scoped>
>>> .wizard-tab-content {
	display: none;
}
>>> .wizard-card-footer {
	display: none;
}
</style>